import { GlobalClaimCapReps } from 'ng2-app/models/dto/lead-assignment/global-claim-cap-reps.model';

export class GetGlobalClaimCapData {
  static readonly type = '[GlobalClaimCapData] Get Global Claim Cap Data';
  constructor() { }
}

export class SetGlobalClaimCapReps {
  static readonly type = '[GlobalClaimCapReps] Set Global Claim Cap Reps';

  constructor(public reps: GlobalClaimCapReps[]) { }
}
